/* EZ product page V3 (sections/ez-pdp.liquid). No dependencies.
   - Gallery: counter, active thumbnail, group underline, strip follows, arrows, swipe hint.
   - Variants: colour/option radios pick the variant; price, compare, save, Affirm amount,
     stock line, sticky bar, quote sheet and URL follow it.
   - Ride Guard: tier chosen from product type + variant price; added to the cart just
     before the scooter so the cart drawer shows both.
   - Ship window: "Ships Oct 1 – Oct 6" from the section's business-day range.
   - Quote sheet: posts to the same Zapier hook and field names as snippets/custom-modal. */
(function () {
  'use strict';

  var WEBHOOK_URL = 'https://hooks.zapier.com/hooks/catch/23932926/uelntck/';
  var ATTR_KEY = 'ez_attr_v1';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function money(cents) {
    var v = cents / 100;
    return '$' + v.toLocaleString('en-CA', { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 });
  }
  function reduced() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }

  function init(root) {
    if (root.dataset.ezReady) return;
    root.dataset.ezReady = '1';

    var product = JSON.parse(($('[data-ez-product]', root) || {}).textContent || '{}');
    var rgEl = $('[data-ez-rg]', root);
    var rg = rgEl ? JSON.parse(rgEl.textContent) : null;
    var rgKind = root.dataset.rgKind || 'E-Bike';
    var colourIndex = parseInt(root.dataset.colourIndex, 10);

    /* ---------------- gallery ---------------- */
    var track = $('[data-ez-track]', root);
    var slides = $$('.ez-slide', root);
    var count = $('[data-ez-count]', root);
    var totalEl = $('[data-ez-total-count]', root);
    var prev = $('[data-ez-prev]', root);
    var next = $('[data-ez-next]', root);
    var strip = $('[data-ez-strip]', root);
    var rail = $('[data-ez-rail]', root);
    var jumps = $$('.ez-jump__link', root);
    var ind = $('[data-ez-ind]', root);
    var current = -1;

    // slides tagged with a colour ("Exterior | Garnet Red | ...") only show for that colour
    function visible() { return slides.filter(function (sl) { return !sl.hidden; }); }
    function go(i, smooth) {
      if (!track || !slides[i] || slides[i].hidden) return;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth === false || reduced() ? 'auto' : 'smooth' });
    }
    function step(dir) {
      var vis = visible(), pos = vis.indexOf(slides[current]);
      var target = vis[Math.max(0, Math.min(vis.length - 1, pos + dir))];
      if (target) go(slides.indexOf(target));
    }
    function keepInView(container, el, horizontal) {
      if (!container || !el || !container.offsetParent) return;
      if (horizontal) container.scrollTo({ left: el.offsetLeft - container.clientWidth / 2 + el.clientWidth / 2, behavior: reduced() ? 'auto' : 'smooth' });
      else container.scrollTo({ top: el.offsetTop - container.clientHeight / 2 + el.clientHeight / 2, behavior: reduced() ? 'auto' : 'smooth' });
    }
    function setActive(i, force) {
      if (i === current && !force) return;
      current = i;
      var vis = visible(), pos = vis.indexOf(slides[i]);
      if (count) count.textContent = pos + 1;
      $$('[data-ez-prog] span', root).forEach(function (sp) { sp.classList.toggle('is-on', +sp.dataset.i === i); });
      if (pos > 0) hideHint();
      if (totalEl) totalEl.textContent = vis.length;
      if (prev) prev.disabled = pos <= 0;
      if (next) next.disabled = pos >= vis.length - 1;
      $$('.ez-th', root).forEach(function (t) { t.classList.toggle('is-active', +t.dataset.ezGo === i); });
      var group = slides[i] && slides[i].dataset.group, activeJump = null;
      jumps.forEach(function (j) { var on = j.dataset.group === group; j.classList.toggle('is-active', on); if (on) activeJump = j; });
      if (ind && activeJump) { ind.style.width = activeJump.offsetWidth + 'px'; ind.style.transform = 'translateX(' + activeJump.offsetLeft + 'px)'; }
      keepInView(strip, $('.ez-th[data-ez-go="' + i + '"]', strip), true);
      keepInView(rail, $('.ez-th[data-ez-go="' + i + '"]', rail), false);
    }
    function nearest() {
      var best = 0, bestD = Infinity, x = track.scrollLeft;
      slides.forEach(function (sl, i) { if (sl.hidden) return; var d = Math.abs(sl.offsetLeft - x); if (d < bestD) { bestD = d; best = i; } });
      return best;
    }
    function filterColour(colour) {
      $$('[data-colour]', root).forEach(function (el) {
        if (el.classList.contains('ez-ci')) return;
        el.hidden = !!colour && el.dataset.colour !== colour;
      });
      // jump links point at the first visible slide of their group
      jumps.forEach(function (j) {
        var first = slides.filter(function (sl) { return !sl.hidden && sl.dataset.group === j.dataset.group; })[0];
        j.hidden = !first; if (first) j.dataset.ezGo = slides.indexOf(first);
      });
      if (track) { var c = slides[current] && !slides[current].hidden ? current : nearest(); go(c, false); setActive(c, true); }
    }
    if (track) {
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return; ticking = true;
        requestAnimationFrame(function () { ticking = false; setActive(nearest()); });
      }, { passive: true });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
      });
      window.addEventListener('resize', function () { var c = current; go(c, false); setActive(c, true); });
      setActive(0, true);
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ez-go]');
      if (b && root.contains(b)) { go(+b.dataset.ezGo); }
    });
    var hint = $('[data-ez-swipe-hint]', root);
    function hideHint() { if (hint) hint.classList.add('is-gone'); }
    if (track) ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) { track.addEventListener(ev, hideHint, { passive: true }); });
    var stripNext = $('[data-ez-strip-next]', root);
    if (stripNext && strip) stripNext.addEventListener('click', function () {
      var atEnd = strip.scrollLeft + strip.clientWidth >= strip.scrollWidth - 4;
      strip.scrollTo({ left: atEnd ? 0 : strip.scrollLeft + strip.clientWidth * 0.7, behavior: reduced() ? 'auto' : 'smooth' });
    });
    if (track) track.addEventListener('click', function (e) {
      if (e.target.closest('a, button, label, video')) return;
      if (e.target.closest('.ez-slide') && typeof openViewer === 'function') openViewer();
    });
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    // one gentle swipe hint on phones, once per session
    try {
      if (track && !reduced() && window.matchMedia('(max-width: 989px)').matches && !sessionStorage.getItem('ez_pdp_nudge')) {
        sessionStorage.setItem('ez_pdp_nudge', '1');
        setTimeout(function () {
          if (current !== 0) return;
          track.style.scrollSnapType = 'none';
          track.scrollTo({ left: 56, behavior: 'smooth' });
          setTimeout(function () { track.scrollTo({ left: 0, behavior: 'smooth' }); setTimeout(function () { track.style.scrollSnapType = ''; }, 450); }, 520);
        }, 1100);
      }
    } catch (_) {}

    /* ---------------- variants ---------------- */
    var idInput = $('[data-ez-variant-id]', root);
    var atc = $('[data-ez-atc]', root);
    var rgToggle = $('[data-ez-rg-toggle]', root);
    var variant = (product.variants || []).filter(function (v) { return idInput && String(v.id) === idInput.value; })[0] || (product.variants || [])[0];

    function selectedOptions() {
      return $$('[data-ez-option]', root).reduce(function (acc, fs) {
        var checked = $('input:checked', fs);
        acc[+fs.dataset.ezOption] = checked ? checked.value : null;
        return acc;
      }, {});
    }
    function findVariant() {
      var sel = selectedOptions();
      return (product.variants || []).filter(function (v) {
        return v.options.every(function (o, i) { return sel[i] == null || sel[i] === o; });
      })[0];
    }
    function rgVariant(v) {
      if (!rg || !v) return null;
      var dollars = v.price / 100;
      var tier = dollars >= 10000 ? 'D' : dollars >= 5000 ? 'C' : dollars >= 3000 ? 'B' : dollars >= 2000 ? 'A' : null;
      if (!tier) return null;
      return rg.variants.filter(function (x) { return x.available && x.option1 === rgKind && String(x.option2 || '').indexOf(tier + ':') === 0; })[0] || null;
    }
    // pre-order: the whole product (its pre-order field or title, from the section) or this variant's name
    function isPre(v) { return root.dataset.preorder === 'true' || /pre-?order/i.test(v.title || ''); }
    function updateTotals() {
      if (!variant) return;
      var r = rgVariant(variant);
      var withRg = rgToggle && rgToggle.checked && r;
      var total = variant.price + (withRg ? r.price : 0);
      $$('[data-ez-total]', root).forEach(function (el) { el.textContent = money(total); });
      var ap = $('[data-ez-atc-price]', root); if (ap) ap.textContent = '· ' + money(total);
      var rp = $('[data-ez-rg-price]', root); if (rp) rp.textContent = r ? '+' + money(r.price) : '';
      var rgRow = rgToggle && rgToggle.closest('.ez-rg'); if (rgRow) { rgRow.hidden = !r; var box = rgRow.parentNode; box.hidden = !r && !box.querySelector('.ez-inc'); }
      var qv = $('[data-ez-quote-variant]', root);
      if (qv) qv.textContent = (colourIndex >= 0 ? variant.options[colourIndex] : variant.title) + (withRg ? ' · Ride Guard' : '');
    }
    function applyVariant(v, initial) {
      if (!v) return;
      variant = v;
      if (idInput) idInput.value = v.id;
      var p = $('[data-ez-price]', root); if (p) p.textContent = money(v.price);
      var cmp = $('[data-ez-compare]', root), save = $('[data-ez-save]', root);
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      if (cmp) { cmp.hidden = !onSale; if (onSale) cmp.textContent = money(v.compare_at_price); }
      if (save) { save.hidden = !onSale; if (onSale) save.textContent = 'Save ' + money(v.compare_at_price - v.price); }
      $$('[data-ez-option]', root).forEach(function (fs) {
        var val = $('[data-ez-opt-value]', fs), checked = $('input:checked', fs);
        if (val && checked) val.textContent = checked.value;
      });
      if (colourIndex >= 0) {
        var colour = v.options[colourIndex];
        $$('[data-ez-colour-name]', root).forEach(function (el) { el.textContent = colour; });
        $$('.ez-ci', root).forEach(function (img) { img.classList.toggle('is-on', img.dataset.colour === colour); });
        if (typeof filterColour === 'function') filterColour(colour);
      }
      var stock = $('[data-ez-stock]', root), st = $('[data-ez-stock-text]', root);
      if (stock && st) {
        stock.classList.toggle('is-pre', v.available && isPre(v));
        stock.classList.toggle('is-out', !v.available);
        if (!v.available) st.textContent = 'Sold out';
        else if (isPre(v)) st.textContent = root.dataset.preorderEta ? 'Pre-order. Expected ' + root.dataset.preorderEta + '.' : 'Pre-order. Call us for the arrival date.';
        else { st.innerHTML = 'In stock. <span data-ez-ship-window></span>.'; shipWindow(); }
      }
      // no shipping window for a sold-out option
      var del = $('[data-ez-delivery]', root); if (del) del.hidden = !v.available;
      if (atc) {
        // clear the theme's own "Sold Out" lock (product-form.js sets it when a cart add is refused)
        var pf = atc.closest('product-form'); if (pf) pf.error = false;
        if (!atc.classList.contains('loading')) atc.removeAttribute('aria-disabled');
        var lab = $('.ez-atc__label', atc); if (lab) lab.classList.remove('hidden');
        var som = $('.sold-out-message', atc); if (som) som.classList.add('hidden');
        atc.disabled = !v.available;
        if (sbarAtc) { sbarAtc.disabled = !v.available; sbarAtc.classList.toggle('is-soldout', !v.available); }
        atc.classList.toggle('is-soldout', !v.available);
        root.toggleAttribute('data-soldout', !v.available);
        // "Pre-Order" for pre-order units, so the button says what happens
        $$('[data-ez-atc-word]', root).forEach(function (w) { w.textContent = (!v.available && w.closest('.ez-sbar')) ? 'Sold Out' : (isPre(v) ? 'Pre-Order' : 'Add to Cart'); });
      }
      var affirmEls = $$('.affirm-as-low-as', root), priceChanged = false;
      affirmEls.forEach(function (el) { if (el.getAttribute('data-amount') !== String(v.price)) { el.setAttribute('data-amount', v.price); priceChanged = true; } });
      if (priceChanged && !initial) {
        try { if (window.affirm && affirm.ui && typeof affirm.ui.refresh === 'function') affirm.ui.refresh(); } catch (_) {}
      }
      if (!initial) try {
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (_) {}
      updateTotals();
    }
    $$('[data-ez-option] input', root).forEach(function (input) {
      input.addEventListener('change', function () { applyVariant(findVariant()); });
    });
    if (rgToggle) rgToggle.addEventListener('change', updateTotals);

    /* ---------------- ship window ---------------- */
    function addBusinessDays(date, n) {
      var d = new Date(date.getTime());
      while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; }
      return d;
    }
    function shipWindow() {
      var min = parseInt(root.dataset.shipMin, 10), max = parseInt(root.dataset.shipMax, 10);
      if (isNaN(min) || isNaN(max)) return;
      var fmt = function (d) { return d.toLocaleDateString('en-CA', { month: 'short', day: 'numeric' }); };
      var now = new Date(), a = addBusinessDays(now, min), b = addBusinessDays(now, max);
      $$('[data-ez-ship-window]', root).forEach(function (el) { el.textContent = 'Ships ' + fmt(a) + ' to ' + fmt(b); });
    }
    shipWindow();

    /* ---------------- delivery method ---------------- */
    $$('.ez-seg input[name^="ez-ship-"]', root).forEach(function (input) {
      input.addEventListener('change', function () {
        $$('[data-ez-ship-panel]', root).forEach(function (panel) { panel.hidden = panel.dataset.ezShipPanel !== input.value; });
      });
    });

    /* ---------------- add to cart (+ Ride Guard first) ---------------- */
    var productForm = $('product-form', root);
    var form = productForm && $('form', productForm);
    var rgReady = false;
    if (productForm && form) {
      productForm.addEventListener('submit', function (e) {
        if (rgReady || !rgToggle || !rgToggle.checked) { rgReady = false; return; }
        var r = rgVariant(variant);
        if (!r) return;
        e.preventDefault(); e.stopImmediatePropagation();
        fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: r.id, quantity: 1 }] })
        }).catch(function () {}).then(function () {
          rgReady = true;
          if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        });
      }, true);
    }

    /* ---------------- sticky bar ---------------- */
    var sbar = $('[data-ez-sbar]', root);
    // Add to Cart: the cart icon nudges once when the button first comes into view
    var atcMain = $('[data-ez-atc]', root);
    if (atcMain && 'IntersectionObserver' in window && !reduced()) {
      var nudgeIo = new IntersectionObserver(function (es) {
        es.forEach(function (en) { if (en.isIntersecting) { setTimeout(function () { atcMain.classList.add('is-nudge'); }, 600); nudgeIo.disconnect(); } });
      }, { threshold: 1 });
      nudgeIo.observe(atcMain);
    }
    // after a successful add, the button confirms for a moment (the cart drawer opens as before)
    if (atcMain) document.addEventListener('afterCartChanged', function (e) {
      var idEl = $('[data-ez-variant-id]', root);
      if (!idEl || !e.detail || String(e.detail.productVariantId) !== String(idEl.value)) return;
      atcMain.classList.add('is-added');
      setTimeout(function () { atcMain.classList.remove('is-added'); }, 2200);
    });
    var sbarAtc = $('[data-ez-sbar-atc]', root);
    if (sbarAtc && atc && atc.disabled) { sbarAtc.disabled = true; sbarAtc.classList.add('is-soldout'); var sw0 = $('[data-ez-atc-word]', sbarAtc); if (sw0) sw0.textContent = 'Sold Out'; }
    var overlayOpen = false, atcVisible = false;
    function syncBar() { if (sbar) sbar.classList.toggle('is-hidden', atcVisible || overlayOpen); }
    if (sbar && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { atcVisible = entries[0].isIntersecting; syncBar(); }, { threshold: 0.1 }).observe(atc);
    }
    if (sbar) { sbar.removeAttribute('aria-hidden'); $$('[tabindex="-1"]', sbar).forEach(function (el) { el.removeAttribute('tabindex'); }); }
    if (sbarAtc && form) sbarAtc.addEventListener('click', function () { if (atc.disabled) return; if (form.requestSubmit) form.requestSubmit(); else atc.click(); });

    /* ---------------- viewer ---------------- */
    var viewer = $('[data-ez-viewer]', root);
    var vtrack = $('[data-ez-viewer-track]', root);
    function openViewer() {
      if (!viewer) return;
      viewer.hidden = false; overlayOpen = true; syncBar();
      requestAnimationFrame(function () { var t = vtrack && $('[data-ez-vslide="' + Math.max(0, current) + '"]', vtrack); if (t) vtrack.scrollLeft = t.offsetLeft; if (vcount) vcount.textContent = vIndex() + 1; });
      var c = $('[data-ez-close-viewer]', viewer); if (c) c.focus();
    }
    function closeViewer() { if (!viewer) return; viewer.hidden = true; overlayOpen = false; syncBar(); }
    $$('[data-ez-open-viewer]', root).forEach(function (b) { b.addEventListener('click', openViewer); });
    var vcount = $('[data-ez-vcount]', root);
    function vVisible() { return $$('.ez-viewer__slide', root).filter(function (sl) { return !sl.hidden; }); }
    function vIndex() { var vis = vVisible(), best = 0, bd = Infinity; vis.forEach(function (sl, k) { var d = Math.abs(sl.offsetLeft - vtrack.scrollLeft); if (d < bd) { bd = d; best = k; } }); return best; }
    if (vtrack) vtrack.addEventListener('scroll', function () { if (vcount) vcount.textContent = vIndex() + 1; }, { passive: true });
    function vStep(dir) { var vis = vVisible(), k = Math.max(0, Math.min(vis.length - 1, vIndex() + dir)); if (vis[k]) vtrack.scrollTo({ left: vis[k].offsetLeft, behavior: reduced() ? 'auto' : 'smooth' }); }
    var vp = $('[data-ez-vprev]', root), vn = $('[data-ez-vnext]', root);
    if (vp) vp.addEventListener('click', function () { vStep(-1); });
    if (vn) vn.addEventListener('click', function () { vStep(1); });
    $$('[data-ez-close-viewer]', root).forEach(function (b) { b.addEventListener('click', closeViewer); });

    /* ---------------- written quote ---------------- */
    var sheet = $('[data-ez-quote]', root);
    var qform = $('[data-ez-quote-form]', root);
    var qdone = $('[data-ez-quote-done]', root);
    var qstatus = $('[data-ez-quote-status]', root);
    function openQuote() {
      if (!sheet) return;
      ensureAttribution();
      sheet.hidden = false; overlayOpen = true; syncBar();
      setTimeout(function () { var f = $('input[name="name"]', sheet); if (f) f.focus(); }, 80);
    }
    function closeQuote() { if (!sheet) return; sheet.hidden = true; overlayOpen = false; syncBar(); }
    $$('[data-ez-open-quote]', root).forEach(function (b) { b.addEventListener('click', openQuote); });
    $$('[data-ez-close-quote]', root).forEach(function (b) { b.addEventListener('click', closeQuote); });
    /* ---------------- pre-owned units ---------------- */
    var po = $('[data-ez-po]', root);
    function openPo() { if (!po) return; po.hidden = false; overlayOpen = true; syncBar(); setTimeout(function () { var x = $('.ez-sheet__x', po); if (x) x.focus(); }, 80); }
    function closePo() { if (!po || po.hidden) return; po.hidden = true; overlayOpen = false; syncBar(); }
    $$('[data-ez-open-po]', root).forEach(function (b) { b.addEventListener('click', openPo); });
    $$('[data-ez-close-po]', root).forEach(function (b) { b.addEventListener('click', closePo); });

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeQuote(); closeViewer(); closePo(); } });

    var submit = $('[data-ez-quote-submit]', root);
    if (submit && qform) submit.addEventListener('click', function () {
      var get = function (n) { var el = $('[name="' + n + '"]', qform); return el ? String(el.value || '').trim() : ''; };
      var hp = get('website'); if (hp) return;
      var missing = ['name', 'postal_code', 'phone'].filter(function (n) { return !get(n); });
      $$('input', qform).forEach(function (el) { el.classList.toggle('is-invalid', missing.indexOf(el.name) !== -1); });
      if (missing.length) {
        qstatus.textContent = 'Please add your first name, postal code and phone.';
        var first = $('[name="' + missing[0] + '"]', qform); if (first) first.focus();
        return;
      }
      qstatus.textContent = '';
      submit.disabled = true;
      var method = ($('[name="contact_method"]:checked', qform) || {}).value || 'Text';
      var withRg = rgToggle && rgToggle.checked;
      var variantText = variant ? variant.title : '';
      var attr = loadAttr();
      var payload = {
        product_title: get('product_title'), product_handle: get('product_handle'), product_url: get('product_url'),
        name: get('name'), phone: get('phone'), email: get('email'),
        postal_code: get('postal_code'), contact_method: method, variant_title: variantText, ride_guard: withRg ? 'yes' : 'no',
        message: 'Written quote request (product page). Postal code: ' + get('postal_code') + '. Reply by: ' + method + '. Variant: ' + variantText + '. Ride Guard: ' + (withRg ? 'yes' : 'no') + '.' + (get('question') ? ' Question: ' + get('question') : ''),
        page_url: window.location.href,
        utm_source: attr.utm_source || '', utm_medium: attr.utm_medium || '', utm_campaign: attr.utm_campaign || '', utm_content: attr.utm_content || '', utm_term: attr.utm_term || '',
        fbclid: attr.fbclid || '', fbp: attr.fbp || '', fbc: attr.fbc || '',
        timezone: (function () { try { return Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (_) { return ''; } })(),
        submitted_at_iso: new Date().toISOString(), event_id: uuid(), user_agent: navigator.userAgent || '', referrer: document.referrer || '',
        source: 'ez-pdp-quote-sheet'
      };
      postZapier(payload).then(function (ok) {
        submit.disabled = false;
        if (!ok) { qstatus.textContent = "Couldn't send. Please try again, or call us."; return; }
        try { if (typeof fbq === 'function') fbq('track', 'Lead', { content_name: payload.product_title, content_category: 'ezrides_quote_sheet', page_url: payload.page_url }, { eventID: payload.event_id }); } catch (_) {}
        qform.hidden = true; if (qdone) qdone.hidden = false;
      });
    });

    applyVariant(variant, true);
  }

  /* attribution, same keys as snippets/custom-modal */
  function getCookie(name) { var m = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)')); return m ? decodeURIComponent(m[2]) : ''; }
  function setCookie(name, value, days) { try { var d = new Date(); d.setTime(d.getTime() + days * 864e5); document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + d.toUTCString() + '; path=/; SameSite=Lax'; } catch (_) {} }
  function loadAttr() { try { return JSON.parse(sessionStorage.getItem(ATTR_KEY) || '{}'); } catch (_) { return {}; } }
  function saveAttr(o) { try { sessionStorage.setItem(ATTR_KEY, JSON.stringify(o)); } catch (_) {} }
  function uuid() { try { if (crypto && crypto.randomUUID) return crypto.randomUUID(); } catch (_) {} return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) { var r = Math.random() * 16 | 0; return (c === 'x' ? r : (r & 3 | 8)).toString(16); }); }
  function ensureAttribution() {
    var p = new URLSearchParams(window.location.search), e = loadAttr();
    var fbclid = p.get('fbclid') || e.fbclid || '';
    var fbp = getCookie('_fbp') || e.fbp || '';
    if (!fbp) { fbp = 'fb.1.' + Math.floor(Date.now() / 1000) + '.' + Math.floor(Math.random() * 1e16); setCookie('_fbp', fbp, 90); }
    var fbc = getCookie('_fbc') || e.fbc || '';
    if (!fbc && fbclid) { fbc = 'fb.1.' + Math.floor(Date.now() / 1000) + '.' + fbclid; setCookie('_fbc', fbc, 90); }
    saveAttr({ fbclid: fbclid, fbp: fbp, fbc: fbc,
      utm_source: p.get('utm_source') || e.utm_source || '', utm_medium: p.get('utm_medium') || e.utm_medium || '',
      utm_campaign: p.get('utm_campaign') || e.utm_campaign || '', utm_content: p.get('utm_content') || e.utm_content || '', utm_term: p.get('utm_term') || e.utm_term || '' });
  }
  function postZapier(payload) {
    var body = JSON.stringify(payload);
    try { if (navigator.sendBeacon && navigator.sendBeacon(WEBHOOK_URL, new Blob([body], { type: 'text/plain' }))) return Promise.resolve(true); } catch (_) {}
    return fetch(WEBHOOK_URL, { method: 'POST', mode: 'no-cors', credentials: 'omit', headers: { 'Content-Type': 'text/plain' }, body: body })
      .then(function () { return true; }).catch(function () { return false; });
  }

  /* ---------- your questions, answered (sections/ez-pdp-answers.liquid) ---------- */
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function goTo(el) {
    el.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    // show where the jump landed: the answer's heading glows for a moment
    el.classList.add('is-flash');
    setTimeout(function () { el.classList.remove('is-flash'); }, 1600);
  }
  function jumpLinks(links) {
    links.forEach(function (a) {
      if (a.dataset.ezBound) return;
      a.dataset.ezBound = '1';
      var t = document.getElementById((a.getAttribute('href') || '').slice(1));
      if (!t) { if (a.matches('[data-ez-ans-link]')) { a.removeAttribute('href'); a.classList.add('is-static'); } return; }
      a.addEventListener('click', function (e) { e.preventDefault(); goTo(t); });
    });
  }
  function initAnswers(sec) {
    if (sec.dataset.ezReady) return;
    sec.dataset.ezReady = '1';
    jumpLinks($$('[data-ez-ans-jump]', sec));

    $$('[data-ez-trip]', sec).forEach(function (box) {
      var km = parseFloat(box.dataset.km);
      var nEl = $('[data-trip-n]', box), word = $('[data-trip-word]', box), bar = $('[data-trip-bar]', box), math = $('[data-trip-math]', box);
      var opts = $$('[data-trip-km]', box);
      function pick(b) {
        opts.forEach(function (o) { o.setAttribute('aria-checked', o === b ? 'true' : 'false'); o.tabIndex = o === b ? 0 : -1; });
        var d = parseFloat(b.dataset.tripKm), rt = d * 2, trips = Math.floor(km / rt), seg = rt / km * 100;
        nEl.textContent = trips;
        word.textContent = trips === 1 ? 'Round Trip' : 'Round Trips';
        bar.innerHTML = '';
        for (var i = 0; i < trips; i++) {
          var s = document.createElement('span');
          s.style.width = 'calc(' + seg + '% - 3px)';
          s.style.animationDelay = (i * 70) + 'ms';
          bar.appendChild(s);
        }
        math.textContent = d + ' km there + ' + d + ' km back = ' + rt + ' km a trip';
      }
      opts.forEach(function (b, i) {
        b.tabIndex = b.getAttribute('aria-checked') === 'true' ? 0 : -1;
        b.addEventListener('click', function () { pick(b); });
        b.addEventListener('keydown', function (e) {
          var k = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 0;
          if (!k) return;
          e.preventDefault();
          var nb = opts[(i + k + opts.length) % opts.length]; pick(nb); nb.focus();
        });
      });
    });

    // "Sit in One at a Showroom" goes to the showroom list on this page when there is one
    var sr = $('[data-ez-ans-showroom]', sec), rooms = document.getElementById('showrooms');
    if (sr && rooms) sr.addEventListener('click', function (e) { e.preventDefault(); goTo(rooms); });

    // the closing "Get My Custom Delivery Plan" opens the buy box's sheet
    var qb = $('[data-ez-ans-quote]', sec), opener = $('.ez-pdp [data-ez-open-quote]');
    if (qb && opener) { qb.hidden = false; qb.addEventListener('click', function () { opener.click(); }); }

    // desktop: the sticky question list marks the answer on screen
    if ('IntersectionObserver' in window) {
      var map = {};
      $$('[data-ez-ans-jump]', sec).forEach(function (a) { map[a.getAttribute('href').slice(1)] = a; });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          Object.keys(map).forEach(function (k) { map[k].classList.toggle('is-on', k === en.target.id); });
        });
      }, { rootMargin: '-35% 0px -60% 0px' });
      $$('.ez-ans__card', sec).forEach(function (c) { io.observe(c); });
    }
  }

  /* ---------- video tour (sections/ez-pdp-vsl.liquid) ---------- */
  function initVsl(sec) {
    if (sec.dataset.ezReady) return;
    sec.dataset.ezReady = '1';
    var id = sec.dataset.videoId, player = $('[data-ez-vsl-player]', sec);
    var list = $('[data-ez-vsl-list]', sec);
    function chs() { return $$('[data-ez-vsl-at]', sec); }
    if (!id || !player) return;

    // loads the privacy-enhanced YouTube player in place, at a given second
    function play(t) {
      t = Math.max(0, Math.floor(t || 0));
      var old = $('iframe', player); if (old) old.remove();
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&playsinline=1&modestbranding=1' + (t ? '&start=' + t : '');
      f.title = 'Video tour';
      f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      f.setAttribute('allowfullscreen', '');
      player.appendChild(f);
      player.classList.add('is-playing');
      var on = null;
      chs().forEach(function (c) { if (+c.dataset.ezVslAt <= t) on = c; });
      chs().forEach(function (c) { c.classList.toggle('is-on', c === on && t > 0); });
    }
    function inView() {
      var r = player.getBoundingClientRect();
      if (r.top < 0 || r.bottom > window.innerHeight) player.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
    }
    function plain(e) { return !(e.metaKey || e.ctrlKey || e.shiftKey); }

    var poster = $('[data-ez-vsl-play]', sec);
    if (poster) poster.addEventListener('click', function (e) { if (!plain(e)) return; e.preventDefault(); play(0); });
    // chapters (server-rendered or built from YouTube below) play from their moment
    sec.addEventListener('click', function (e) {
      var c = e.target.closest && e.target.closest('[data-ez-vsl-at]');
      if (!c || !plain(e)) return;
      e.preventDefault(); play(+c.dataset.ezVslAt); inView();
    });

    // chapters built from YouTube get the product's chapter pictures (custom.video_chapter_images), in order
    var chImgs = (sec.dataset.chImg || '').split(' ').filter(Boolean);
    function decorate() {
      chs().forEach(function (a, i) {
        if ($('img', a) || !chImgs[i]) return;
        var img = document.createElement('img');
        img.src = chImgs[i]; img.alt = ''; img.width = 400; img.height = 225; img.loading = 'lazy';
        a.insertBefore(img, a.firstChild);
      });
    }

    // YouTube: real length and views for every video; chapters from the description when none are on file
    var ytKey = sec.dataset.ytKey;
    function fmtTime(sec2) { var h = Math.floor(sec2 / 3600), m = Math.floor(sec2 % 3600 / 60), x = sec2 % 60; return (h ? h + ':' + (m < 10 ? '0' : '') : '') + m + ':' + (x < 10 ? '0' : '') + x; }
    function fmtViews(n) {
      if (n >= 1e6) return (Math.floor(n / 1e5) / 10) + 'M+';
      if (n >= 1e4) return Math.floor(n / 1e3) + 'K+';
      if (n >= 1e3) return (Math.floor(n / 100) / 10) + 'K+';
      return String(n);
    }
    function isoSecs(d) { var m = /PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?/.exec(d || ''); return m ? (+m[1] || 0) * 3600 + (+m[2] || 0) * 60 + (+m[3] || 0) : 0; }
    function applyYt(d) {
      var total = isoSecs(d.dur);
      if (total) {
        var durEl = $('[data-ez-vsl-dur]', sec);
        if (durEl) { durEl.textContent = fmtTime(total); durEl.hidden = false; }
        var h2 = $('[data-ez-vsl-heading]', sec), tpl = sec.dataset.headingMinutes;
        if (h2 && tpl && total >= 60 && !sec.hasAttribute('data-has-minutes')) h2.textContent = tpl.replace('[minutes]', Math.floor(total / 60));
      }
      var viewsEl = $('[data-ez-vsl-views]', sec);
      if (viewsEl && d.views >= 1000) { viewsEl.textContent = fmtViews(d.views) + ' Views on YouTube'; viewsEl.hidden = false; }
      if (list && !chs().length && d.desc) {
        var out = [];
        d.desc.split(/\r?\n/).forEach(function (line) {
          var m = /^\s*((?:\d{1,2}:)?\d{1,2}:\d{2})\s*[-–—|:)]?\s*(.{2,80})$/.exec(line);
          if (!m) return;
          var p = m[1].split(':').map(Number), secs2 = p.length === 3 ? p[0] * 3600 + p[1] * 60 + p[2] : p[0] * 60 + p[1];
          if (secs2 > 0) out.push({ t: secs2, label: m[1], title: m[2].trim() });
        });
        if (out.length >= 2) {
          out.forEach(function (c) {
            var li = document.createElement('li'), a = document.createElement('a');
            a.className = 'ez-vsl__ch'; a.href = 'https://www.youtube.com/watch?v=' + encodeURIComponent(id) + '&t=' + c.t + 's';
            a.target = '_blank'; a.rel = 'noopener'; a.dataset.ezVslAt = c.t; a.dataset.title = c.title;
            a.innerHTML = '<span class="ez-vsl__ch-text"><span class="ez-vsl__ch-time"></span><span class="ez-vsl__ch-title"></span></span><span class="ez-vsl__ch-go" aria-hidden="true"><svg width="20" height="20" viewBox="0 0 20 20"><circle cx="10" cy="10" r="10" fill="currentColor"/><path d="M8 6.2v7.6L14 10Z" fill="#fff"/></svg></span>';
            $('.ez-vsl__ch-time', a).textContent = c.label; $('.ez-vsl__ch-title', a).textContent = c.title;
            li.appendChild(a); list.appendChild(li);
          });
          var box = $('[data-ez-vsl-chapters]', sec); if (box) box.hidden = false;
          decorate();
        }
      }
    }
    if (ytKey) {
      var ck = 'ez_yt_' + id, cached = null;
      try { cached = JSON.parse(localStorage.getItem(ck) || 'null'); } catch (_) {}
      if (cached && Date.now() - cached.t < 864e5) applyYt(cached.d);
      else {
        fetch('https://www.googleapis.com/youtube/v3/videos?part=contentDetails,statistics,snippet&id=' + encodeURIComponent(id) + '&key=' + encodeURIComponent(ytKey))
          .then(function (r) { return r.json(); })
          .then(function (j) {
            var it = j && j.items && j.items[0]; if (!it) return;
            var d = { dur: it.contentDetails && it.contentDetails.duration, views: +((it.statistics || {}).viewCount || 0), desc: (it.snippet || {}).description || '' };
            try { localStorage.setItem(ck, JSON.stringify({ t: Date.now(), d: d })); } catch (_) {}
            applyYt(d);
          })
          .catch(function () {});
      }
    }

    // the gallery's Video slide (and its full-screen copy) plays here instead of leaving the page
    $$('a[href*="' + id + '"]').forEach(function (a) {
      if (sec.contains(a)) return;
      a.removeAttribute('target');
      a.addEventListener('click', function (e) {
        if (!plain(e)) return;
        e.preventDefault(); e.stopPropagation();
        var close = a.closest('[data-ez-viewer]') && $('[data-ez-close-viewer]');
        if (close) close.click();
        play(0); inView();
      }, true);
    });

    // Add to Cart under the video submits the buy box's form (colour, price, Ride Guard as chosen there)
    var buy = $('[data-ez-vsl-buy]', sec), atc = $('.ez-pdp [data-ez-atc]'), form = atc && atc.closest('form');
    if (buy && atc && form) {
      var vbtn = $('[data-ez-vsl-atc]', sec), vprice = $('[data-ez-vsl-price]', sec), src = $('.ez-pdp [data-ez-atc-price]');
      var vword = $('[data-ez-vsl-word]', sec), srcWord = $('.ez-pdp [data-ez-atc-word]');
      var sync = function () { if (src && vprice) vprice.textContent = atc.disabled ? '' : src.textContent; if (vword && srcWord) vword.textContent = atc.disabled ? 'Sold Out' : srcWord.textContent; vbtn.disabled = atc.disabled; };
      sync();
      new MutationObserver(sync).observe(atc, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
      vbtn.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(); else atc.click(); });
      var plan = $('[data-ez-vsl-plan]', sec), opener = $('.ez-pdp [data-ez-open-quote]');
      if (plan && opener) plan.addEventListener('click', function () { opener.click(); });
      else if (plan) plan.hidden = true;
      buy.hidden = false;
    }
  }

  function boot() {
    ensureAttribution();
    $$('.ez-pdp').forEach(init);
    $$('[data-ez-vsl]').forEach(initVsl);
    $$('.ez-ans').forEach(initAnswers);
    jumpLinks($$('[data-ez-ans-link]'));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('.ez-pdp'); if (r) init(r);
    var v = e.target.querySelector('[data-ez-vsl]'); if (v) initVsl(v);
    var a = e.target.querySelector('.ez-ans'); if (a) initAnswers(a);
    jumpLinks($$('[data-ez-ans-link]'));
  });
})();
